/**
 * Aura AGM (MULTIPLE shareholders) chatflow. steps/handleEvent 는 형제 sole 플로우 재사용
 * (title → 회사 선택 → confirm + person/date/address 조회 플러밍 동일). id·환영문만 별도.
 */
import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/types';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import { auraAgmFlow } from '../../agm/chatflows/auraAgmFlow';

export const auraAgmMultiFlow: ChatFlow = {
  ...auraAgmFlow,
  id: 'aura-agm-multi',
  taskCodeMatch: ['CAU003'],
  categoryMatch: ['aura agm', 'agm', 'annual general meeting', 'multiple', 'multiple shareholders'],

  getInitialMessages(preSet: PreSetSelection): ConversationMessage[] {
    const docCount = preSet.documents.length;
    return [
      {
        role: 'ai',
        content:
          `Welcome to **Aura AGM** (Unaudited · Multiple Shareholders).\n\n` +
          `This preset prepares a live document package` +
          (docCount > 0 ? ` (${docCount} template(s) linked)` : '') +
          `: Letter of Notification & Lodgement of AR, AGM Documents (DRW / Notice / Consent to Short Notice / ` +
          `Minutes / Attendance List / Statements), DDF (per director), and conditional Notices for Controller ` +
          `(Individual & Corporate).\n\n` +
          `First, enter a **Task Title**, then select the **company**.`,
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },
};
